import React from 'react';
import UserAuthLayout from '../../Layout/UserAuthLayout';
import SwappingCard from '../Swapping/SwappingCard';

const Swapp = () => {
  return (
    <>
      <UserAuthLayout>
        <section
          className='d-flex align-items-center justify-content-center'
          style={{ minHeight: '85vh' }}
        >
          <div className='container'>
            <div className='row justify-content-center'>
              <div className='col-12'>
                <SwappingCard show={false} />
              </div>
            </div>
          </div>
        </section>
      </UserAuthLayout>
    </>
  );
};

export default Swapp;
